const MarshallIslandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111844)">
      <path
        d="M20 40C31.0456 40 40 31.0456 40 20C40 16.6435 39.1719 13.4808 37.7108 10.7031L19.9765 20.0234L29.2969 2.28922C26.5192 0.828125 23.3565 0 20 0C8.95437 0 0 8.95437 0 20C0 25.5229 2.23859 30.5229 5.85781 34.1422C9.47711 37.7615 14.4771 40 20 40Z"
        fill="#0052B4"
      />
      <path
        d="M37.6897 10.724C36.7742 8.98152 35.584 7.34551 34.1188 5.88035C32.6536 4.4152 31.0178 3.22496 29.2752 2.30957L5.83447 34.1646L37.6897 10.724Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.83447 34.1652L37.6897 10.7245C36.7742 8.98203 35.584 7.34602 34.1188 5.88086L5.83447 34.1652Z"
        fill="#FF9811"
      />
      <path
        d="M17.3676 11.7286L14.9251 12.8775L16.2258 15.2431L13.5734 14.7357L13.2373 17.415L11.3898 15.4443L9.54234 17.415L9.20641 14.7357L6.55406 15.2429L7.85461 12.8774L5.41211 11.7286L7.85469 10.5796L6.55406 8.2141L9.20625 8.72137L9.54242 6.04199L11.3898 8.0127L13.2373 6.04199L13.5734 8.72137L16.2259 8.2141L14.9252 10.5796L17.3676 11.7286Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111844">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MarshallIslandSvg;
